<template>
  <div class="d-flex flex-wrap justify-space-between secondary--text filter-options">
    <!-- For selecting followers range -->
    <filter-followers
      :module-id="moduleId"
      class="mx-md-2 my-2 my-md-0"
    />

    <!-- For selecting a country of origin -->
    <filter-location
      :module-id="moduleId"
      class="mx-md-2 my-2 my-md-0"
    />

    <!-- created date range selector -->
    <filter-created
      :module-id="moduleId"
      class="mx-md-2 my-2 my-md-0"
    />

    <!-- likes range selector -->
    <filter-likes
      :module-id="moduleId"
      class="mx-md-2 my-2 my-md-0"
    />

    <!-- tag an account for sponsorship -->
    <filter-sponsor
      :module-id="moduleId"
      class="mx-md-2 my-2 my-md-0"
    />

    <!-- multiple hashtags -->
    <filter-hashtags
      :module-id="moduleId"
      class="mx-md-2 my-2 my-md-0"
    />

    <!-- tag multiple accounts by username -->
    <filter-mentions
      :module-id="moduleId"
      class="mx-md-2 my-2 my-md-0"
    />
  </div>
</template>

<script>
const FilterFollowers = () => import("@/blocks/paid-collaborations/FilterFollowers.vue")
const FilterMentions = () => import("@/blocks/paid-collaborations/FilterMentions.vue")
const FilterLocation = () => import("@/blocks/paid-collaborations/FilterLocation.vue")
const FilterHashtags = () => import("@/blocks/paid-collaborations/FilterHashtags.vue")
const FilterCreated = () => import("@/blocks/paid-collaborations/FilterCreated.vue")
const FilterSponsor = () => import("@/blocks/paid-collaborations/FilterSponsor.vue")
const FilterLikes = () => import("@/blocks/paid-collaborations/FilterLikes.vue")

export default {
  name: "FilterOptions",

  props: {
    moduleId: {
      type: [Symbol, String, Number],
      required: true
    }
  },

  components: {
    FilterFollowers,
    FilterMentions,
    FilterLocation,
    FilterHashtags,
    FilterCreated,
    FilterSponsor,
    FilterLikes,
  }
}
</script>

<style lang="stylus" scoped>
.vertical-divider
  height 1em
  width 2px
  margin-top 0
</style>

<style lang="stylus">
.filter-options
  .v-icon
    color #373b56

  .filter-title
    color #4c4c4c
</style>
